/**
 * Canvas Studio API — thin wrapper over the shared axios instance
 * (auth header + /api base are already configured there).
 * Backend: /api/canvas (see backend/routes/canvasRoutes.js).
 */
import api from '../../../api/axios';

export const canvasApi = {
  list: () => api.get('/canvas').then((r) => r.data),
  folders: () => api.get('/canvas/folders').then((r) => r.data),
  get: (id) => api.get(`/canvas/${id}`).then((r) => r.data),
  create: (body) => api.post('/canvas', body).then((r) => r.data),
  update: (id, body) => api.put(`/canvas/${id}`, body).then((r) => r.data),
  remove: (id) => api.delete(`/canvas/${id}`).then((r) => r.data),
  // Version snapshots
  listVersions: (id) => api.get(`/canvas/${id}/versions`).then((r) => r.data),
  createVersion: (id, label) => api.post(`/canvas/${id}/versions`, { label }).then((r) => r.data),
  restoreVersion: (id, versionId) => api.post(`/canvas/${id}/versions/${versionId}/restore`).then((r) => r.data),
};

export default canvasApi;
